import { fusionResult, getItem, type InventoryState, type ItemTemplate } from '@shefira/shared';

/**
 * The smelter's groups (ADR 0018): the bag's fusable pieces by kind, and the
 * worn ones of the same kind, which are shown but never counted.
 */

export interface FusionGroup {
  template: ItemTemplate;
  /** Pieces of this kind in the bag: the only ones the smelter takes (ADR 0018). */
  count: number;
  /** Pieces of this kind worn: shown, never counted. */
  worn: number;
}

/** The fusable pieces by kind, bag and body, the fullest groups first. */
export function fusionGroups(inventory: InventoryState | undefined): FusionGroup[] {
  if (inventory === undefined) return [];
  const counts = new Map<string, number>();
  for (const entry of inventory.bag) {
    counts.set(entry.item.templateId, (counts.get(entry.item.templateId) ?? 0) + 1);
  }
  const worn = new Map<string, number>();
  for (const piece of Object.values(inventory.equipped)) {
    worn.set(piece.templateId, (worn.get(piece.templateId) ?? 0) + 1);
  }
  const groups: FusionGroup[] = [];
  for (const templateId of new Set([...counts.keys(), ...worn.keys()])) {
    const template = getItem(templateId);
    const count = counts.get(templateId) ?? 0;
    const wornCount = worn.get(templateId) ?? 0;
    if (template !== undefined && fusionResult(template) !== undefined && count + wornCount >= 1) {
      groups.push({ template, count, worn: wornCount });
    }
  }
  return groups.sort(
    (a, b) => b.count - a.count || a.template.name.localeCompare(b.template.name),
  );
}
